import { BrowserState } from "Types/state";
import { UpdateViewportActions } from "../actions/browser";
import { UPDATE_VIEWPORT_DIMENSIONS, UPDATE_VIEWPORT_IS_MOBILE } from "../constants/browser";

const initialState: BrowserState = {
    height: 0,
    isMobile: false,
    width: 0,
};

function browser(state: BrowserState = initialState, action: UpdateViewportActions): BrowserState {
    switch (action.type) {
        case UPDATE_VIEWPORT_DIMENSIONS:
            return { ...state, ...action.data.dimensions };
        case UPDATE_VIEWPORT_IS_MOBILE:
            return { ...state, isMobile: action.data.isMobile };
        default:
            return state;
    }
}

export default browser;
